module.exports = __webpack_public_path__ + "static/media/slide-time.c2a6d7ef.svg";